module.exports = __webpack_public_path__ + "648e06f4fef0b52b31210b01f9c15d82.svg";